import { createFileRoute } from '@tanstack/react-router'

import { ApplicantCasesLayout } from '@/pages/dashboard/applicants/layout'
import { type CasesSortKey, type CasesSortOrder } from '@/pages/dashboard/types'

export const Route = createFileRoute('/_dashboard/applicants/$applicantId')({
  validateSearch: (
    search: Record<string, unknown>
  ): {
    sortKey?: CasesSortKey
    sortOrder?: CasesSortOrder
  } => {
    return {
      sortKey: search.sortKey as CasesSortKey,
      sortOrder: search.sortOrder as CasesSortOrder,
    }
  },
  component: ApplicantCasesLayout,
})
